import React, { useState } from 'react';
import { VIDEO } from '../../data/dgpt';
import { useVimeoProgress } from '../../hooks/useVimeoProgress';

/**
 * The live Vimeo player. Mounted only after the visitor presses Play.
 * Rendered at native 16:9 with no filters, opacity, transforms or overlays.
 */
export function VideoPlayer() {
  const [iframe, setIframe] = useState<HTMLIFrameElement | null>(null);
  useVimeoProgress(iframe);
  return <div className="relative w-full overflow-hidden rounded-2xl bg-black" style={{
    aspectRatio: '16 / 9'
  }} data-id="element-102" data-mp="1zbkvdivf4ej4">
      <iframe ref={setIframe} src={`${VIDEO.embedUrl}&autoplay=1`} title={VIDEO.title} allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="absolute inset-0 h-full w-full border-0" data-id="element-103" data-mp="1uaned9m59qj7" />
    </div>;
}